import React, { useState } from "react"
import { connect } from 'react-redux'
import { useStaticQuery, graphql } from "gatsby"
import * as Boxes from 'components/theme/Boxes'
import * as Buttons from 'components/theme/Buttons'
import { RowSmallGap, Column4 } from 'components/theme/Layout'
import ModalHubspot from 'components/common/alerts/ModalHubspot'
import { handleModalHubspot } from 'actions/modal'
import HubspotForms from 'components/forms/hubspot/default'

const ContactBanner = ({ handleModalHubspot }) => {

  const [form, setForm] = useState(null);
  const [formTitle, setFormTitle] = useState(null);
  const { allFile } = useStaticQuery(
    graphql`
      query {
        allFile ( filter: { relativeDirectory: {eq: "assets/contact"} }) {
          edges {
            node {
              name,
              publicURL
            }
          }
        }
      }
    `
  )

  const assets = {
    'calendar': allFile.edges.filter((item) => item.node.name === 'calendar')[0].node,
    'phone': allFile.edges.filter((item) => item.node.name === 'phone')[0].node,
    'hangout': allFile.edges.filter((item) => item.node.name === 'hangout')[0].node
  };

  const appointment = () => {
    if (typeof window !== 'undefined') {
      window.open('https://app.hubspot.com/meetings/achretien/1stcontact', '_blank');
    }
  }

  const handleHubspotForm = (type, title) => {
    setForm(type)
    setFormTitle(title)
    handleModalHubspot()
  }

  return (
    <React.Fragment>
      <RowSmallGap className="centered" data-aos="fade-up">
        <Column4>
          <Boxes.BoxShadow className="fixed-height contact" style={{ minHeight: '35rem' }}>
            <div>
              <div>
                <p>
                  <span style={{ fontSize: '2.5rem' }}>Discutons 15min ensemble.</span><br />
                  Choisissez votre créneau.
                </p>
              </div>
              <div>
                <img src={assets.calendar.publicURL} alt="Choisir un rendez-vous" />
              </div>
            </div>
            <Buttons.ButtonBottom className="small center contact" onClick={appointment}>
              Je prends RDV
            </Buttons.ButtonBottom>
          </Boxes.BoxShadow>
        </Column4>
        <Column4>
          <Boxes.BoxShadow className="fixed-height contact" style={{ minHeight: '35rem' }}>
            <div>
              <div>
                <p>
                  <span style={{ fontSize: '2.5rem' }}>On vous rappelle dans l'heure.</span>
                </p>
              </div>
              <div>
                <img src={assets.phone.publicURL} alt="Contact" />
              </div>
            </div>
            <Buttons.ButtonBottom
              className="small center contact"
              onClick={() => handleHubspotForm('call', 'Appelez-moi')}
            >
              Appelez-moi
            </Buttons.ButtonBottom>
          </Boxes.BoxShadow>
        </Column4>
        <Column4>
          <Boxes.BoxShadow className="fixed-height contact" style={{ minHeight: '35rem' }}>
            <div>
              <div>
                <p>
                  <span style={{ fontSize: '2.5rem' }}>Questionnez nos clients.</span>
                </p>
              </div>
              <div>
                <img src={assets.hangout.publicURL} alt="Mise en relation" />
              </div>
            </div>
            <Buttons.ButtonBottom
              className="small center contact"
              onClick={() => handleHubspotForm('hangout', 'Questionnez nos clients')}
            >
              Mettez-moi en relation
            </Buttons.ButtonBottom>
          </Boxes.BoxShadow>
        </Column4>
      </RowSmallGap>

      <ModalHubspot title={formTitle}>
        <div>
          <HubspotForms id={form} />
        </div>
      </ModalHubspot>
    </React.Fragment>
  )
}

const mapDispatchToProps = (dispatch) => ({
  handleModalHubspot: () => dispatch(handleModalHubspot())
});
export default connect(null, mapDispatchToProps)(ContactBanner);